export const CustomRegisterForm = "CustomRegisterForm";
export const ParentNameActivity = "Activity";